<template>
  <div>
      <font style="font-size: 11.5px">&nbsp;Seleccione un perfil</font><br>
      <v-select :options="SeleccionUsuario" :reduce="SeleccionUsuario => SeleccionUsuario.value" label="text" class="w-full h-100" placeholder="--Seleccione--" v-model="selecciondeusuario" ref="selecciondeusuario" :class="classvalidar_selecciondeusuario" />
      <vs-popup title="Errores en excel de los codigos" :active.sync="modalErrores" style="padding: 0% !important;">
          <div class="w-full" style="background: rgb(121,9,9); padding: 20px; border-radius: 5px; background: linear-gradient(90deg, rgba(121,9,9,1) 28%, rgba(255,0,48,1) 100%); color: white;">
              <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                      <b>Código</b>
                  </div>
              </div>
              <vs-divider></vs-divider>
              <div :key="index" v-for="(item, index) in errores">
                  <div class="vx-row">
                      <div class="vx-col sm:w-1/2 w-full">
                          <span v-if="item.codigo"> {{item.codigo}} </span>
                      </div>
                  </div>
              </div>
          </div>
      </vs-popup>
      <vs-popup title="Códigos no encontrados" :active.sync="modalCedulas" @accept="recargar()" @close="recargar()" @cancel="recargar()" style="padding: 0% !important;">
          <div class="w-full" style="background: rgb(235,147,25); background: linear-gradient(90deg, rgba(235,147,25,1) 28%, rgba(255,166,0,1) 100%); color: white; border-radius: 5px; padding: 10px;">
              <div class="vx-row">
                  <div class="vx-col w-full" align="center">
                      <b>Codigos a las que no se aplicaron correctamente</b>
                  </div>
              </div>
              <vs-divider></vs-divider>
              <div :key="index" v-for="(item, index) in cedulas_no_encontradas">
                  <div class="vx-row">
                      <div class="vx-col w-full" align="center"> <span> {{item}} </span> </div>
                  </div>
              </div>
          </div>
      </vs-popup>
      <vs-popup small title="Confirmación" :active.sync="modalConfirm">
          <div class="w-full mb-base" align="center">
              <h4>¿Estás seguro de {{ tablaSeleccionada === 1 ? 'actualizar' : 'registrar' }} estos {{ arraySendData.length }} usuarios?</h4>
              <p v-if="tablaSeleccionada === 1 && activarUsuariosInactivos" style="color: #ff9f43; margin-top: 10px; font-weight: bold;">
                  <i class="feather icon-alert-triangle"></i> También se activarán los usuarios inactivos
              </p>
              <p v-if="tablaSeleccionada === 1 && mantenerGrupoActual" style="color: #28c76f; margin-top: 10px; font-weight: bold;">
                  <i class="feather icon-check-circle"></i> Se mantendrá el grupo/rol actual de los usuarios
              </p>
          </div>
          <div class="w-full" align="center">
              <vs-button class="mb-2" color="danger" type="gradient" @click="procesarPagos()"> Confirmar </vs-button>
          </div>
      </vs-popup>
      <div>
          <div class="mb-6 mt-5" align="center">
              <div class="vx-col w-full" v-if="tableData.length == 0">
                  <p style="color:#12481A;">
                      <i class="fa fa-file" aria-hidden="true"></i> Estos <b>usuarios</b> pasarán a ser registrados <span style="font-weight: bold;">(no ingrese más de 1000 registros en una sola carga.)</span>
                  </p>
              </div>
              <!-- Sección de importación: solo visible cuando no hay datos cargados -->
            <div v-if="tableData.length === 0">
              <br />
              <import-excel :onSuccess="loadDataInTable" class="mb-4" />
              <div>
                  <vs-row>
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" vs-sm="12" vs-xs="12">
                          <vs-card>
                              <div class="header">
                                  <div style="display: flex; align-items: center; justify-content: flex-start; margin-bottom: 8px;">
                                      <vs-button color="primary" type="gradient" style="font-size: 12px; padding: 4px 12px; min-width: unset;" @click="descargarFormatoExcel">Descargar formato</vs-button>
                                      <p style="font-weight: bold; margin-left: 12px; margin-bottom: 0;">Formato del archivo excel</p>
                                  </div>
                                  <table class="tabla">
                                      <tr>
                                          <th class="th1">cedula</th>
                                          <th class="th1">nombres</th>
                                          <th class="th1">apellidos</th>
                                          <th class="th1">correo</th>
                                          <th class="th1">institucion_id</th>
                                      </tr>
                                      <tr>
                                          <td class="td1">123</td>
                                          <td class="td1">xxx</td>
                                          <td class="td1">xxx</td>
                                          <td class="td1">@xxx</td>
                                          <td class="td1">1</td>
                                      </tr>
                                  </table>
                              </div>
                          </vs-card>
                      </vs-col>
                  </vs-row>
              </div>
            </div>
            <!-- Botón para cargar otro archivo: solo visible cuando hay datos cargados -->
            <div v-else class="mb-4" style="display: flex; justify-content: center;">
              <vs-button color="warning" type="gradient" icon-pack="feather" icon="icon-upload" @click="limpiarArchivo">
                <i class="feather icon-refresh-cw mr-2"></i> Cargar otro archivo
              </vs-button>
            </div>
              <!-- {{tableData}} -->
              <vs-row v-if="codigosPerdidos == true">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                      <vs-alert active="true">
                          Se registraron {{ porcentaje }} usuarios
                      </vs-alert>
                  </vs-col>
              </vs-row>
          </div>
      </div>
      <vs-row v-if="codigosPerdidos == true && registroProblemas.length > 0">
          <vs-card>
              <div class="header">
                  <span style="font-weight:bold;" class="text-danger">Registro de usuarios con problemas</span>
              </div>
              <vs-table max-items="10" search pagination :data="registroProblemas">
                  <template slot="header">
                      <vs-chip color="primary">Cantidad: <b> {{ registroProblemas.length }}</b></vs-chip>
                      <div style="align-content: end; text-align: right;">
                          <vs-button @click="exportToExcel" color="primary" type="gradient" class="m-4">Exportar a Excel</vs-button>
                      </div>
                  </template>

                  <template slot="thead">
                      <vs-th>Cédula</vs-th>
                      <vs-th>Nombres</vs-th>
                      <vs-th>Apellidos</vs-th>
                      <vs-th>Correo</vs-th>
                      <vs-th>institucion_id</vs-th>
                      <vs-th>Problema</vs-th>
                  </template>
                  <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td>
                              {{data[indextr].cedula}}<br>
                          </vs-td>
                          <vs-td>
                              {{data[indextr].nombres}}<br>
                          </vs-td>
                          <vs-td>
                              {{data[indextr].apellidos}}<br>
                          </vs-td>
                          <vs-td>
                              {{data[indextr].correo}}<br>
                          </vs-td>
                          <vs-td>
                              {{data[indextr].institucion_id}}<br>
                          </vs-td>
                          <vs-td>
                              {{data[indextr].problema}}<br>
                          </vs-td>
                      </vs-tr>
                  </template>
              </vs-table>
          </vs-card>
      </vs-row>
            <vx-card v-if="(Array.isArray(arrayUsuarios) && arrayUsuarios.length) || (Array.isArray(arrayUsuariosNoEncontrados) && arrayUsuariosNoEncontrados.length)">
                <div class="flex mb-3" style="align-items: center; gap: 24px;">
                    <li style="list-style: none; margin-right: 16px;">
                        <vs-radio v-model="tablaSeleccionada" vs-name="radiosUsuarios" :vs-value="0">
                            Usuarios no existen ({{ usuariosNoExistenCount }})
                        </vs-radio>
                    </li>
                    <li style="list-style: none;">
                        <vs-radio v-model="tablaSeleccionada" vs-name="radiosUsuarios" :vs-value="1">
                            Usuarios existen ({{ usuariosExistentesCount }})
                        </vs-radio>
                    </li>
                </div>
                <!--USUARIOS EXISTEN-->
                <div v-if="tablaSeleccionada === 1">
                    <!-- Filtros de estado -->
                    <div class="flex mb-3" style="align-items: center; gap: 16px; justify-content: center; flex-wrap: wrap;">
                        <span style="font-weight: bold; margin-right: 8px;">Filtrar por estado:</span>
                        <vs-radio v-model="filtroEstadoUsuario" vs-name="filtroEstado" :vs-value="0">
                            Todos ({{ usuariosExistentesCount }})
                        </vs-radio>
                        <vs-radio v-model="filtroEstadoUsuario" vs-name="filtroEstado" :vs-value="1">
                            Activos ({{ usuariosActivosCount }})
                        </vs-radio>
                        <vs-radio v-model="filtroEstadoUsuario" vs-name="filtroEstado" :vs-value="2">
                            Inactivos ({{ usuariosInactivosCount }})
                        </vs-radio>
                    </div>
                    <vs-table multiple v-model="usuariosSeleccionados" stripe pagination :max-items="10" search :data="arrayUsuariosFiltrados">
                        <template slot="header">
                            <div style="display: flex; flex-direction: column; align-items: center; width: 100%; gap: 12px;">
                                <div style="display: flex; justify-content: center; align-items: center; gap: 16px;">
                                    <vs-chip color="primary">
                                        Seleccionados: {{ usuariosSeleccionados.length }}
                                    </vs-chip>
                                    <vs-button v-if="usuariosSeleccionados.length > 0" color="success" type="gradient" icon-pack="feather" icon="icon-refresh-cw" @click="arraySendData = usuariosSeleccionados;openConfirm()">
                                        Actualizar usuarios ({{ usuariosSeleccionados.length }})
                                    </vs-button>
                                    <vs-button v-if="arrayUsuariosFiltrados.length > 0" color="dark" type="gradient" icon-pack="feather" icon="icon-download" @click="exportarExisten()">
                                        Exportar a Excel ({{ arrayUsuariosFiltrados.length }})
                                    </vs-button>
                                </div>
                                <div style="display: flex; align-items: center; gap: 16px; flex-wrap: wrap;">
                                    <vs-checkbox v-model="activarUsuariosInactivos" color="warning">
                                        Activar usuarios inactivos
                                    </vs-checkbox>
                                    <vs-checkbox v-model="mantenerGrupoActual" color="success">
                                        Mantener grupo/rol actual
                                    </vs-checkbox>
                                </div>
                            </div>
                        </template>
                        <template slot="thead">
                            <vs-th>Cédula</vs-th>
                            <vs-th>ID Usuario</vs-th>
                            <vs-th>Nombres</vs-th>
                            <vs-th>Apellidos</vs-th>
                            <vs-th>Email</vs-th>
                            <vs-th>Institución</vs-th>
                            <vs-th>Grupo</vs-th>
                            <vs-th>Estado</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :is-selected="usuariosSeleccionados.includes(data[indextr])">
                                <vs-td>{{ data[indextr].cedula }}</vs-td>
                                <vs-td>{{ data[indextr].idusuario }}</vs-td>
                                <vs-td>
                                  <div v-if="tr.nombres != tr.nombres_bd">
                                    <b>Nombres anterior:</b>
                                    <p>{{ tr.nombres_bd }}</p>
                                    <b>Nombres a modificar:</b>
                                    <p>{{ tr.nombres }}</p>
                                  </div>
                                  <div v-else>
                                    {{tr.nombres}}
                                  </div>
                                </vs-td>
                                <vs-td>
                                  <div v-if="tr.apellidos != tr.apellidos_bd">
                                    <b>Apellidos anterior:</b>
                                    <p>{{ tr.apellidos_bd }}</p>
                                    <b>Apellidos a modificar:</b>
                                    <p>{{ tr.apellidos }}</p>
                                  </div>
                                  <div v-else>
                                    {{tr.apellidos}}
                                  </div>
                                </vs-td>
                                <vs-td>
                                  <div v-if="tr.correo != tr.email_bd">
                                    <br>
                                    <b>Email anterior:</b>
                                    <p>{{ tr.email_bd }}</p>
                                    <b>Email a modificar:</b>
                                    <p>{{ tr.correo }}</p>
                                  </div>
                                  <div v-else>
                                    {{ tr.correo }}
                                  </div>
                                </vs-td>
                                <vs-td>
                                  <div v-if="tr.nombreInstitucion != tr.nombreInstitucion_db">
                                    <br>
                                    <b>Institución anterior:</b>
                                    <p>{{ tr.nombreInstitucion_db }}</p>
                                    <b>Institución a modificar:</b>
                                    <p>{{ tr.nombreInstitucion }}</p>
                                  </div>
                                  <div v-else>
                                    {{ tr.nombreInstitucion }}
                                  </div>
                                </vs-td>
                                <vs-td>{{ data[indextr].grupo }}</vs-td>
                                <vs-td>
                                    <vs-chip :color="data[indextr].estadoUsuario === 1 ? 'success' : 'danger'">
                                        {{ data[indextr].estado_usuario }}
                                    </vs-chip>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
                <div v-else-if="tablaSeleccionada === 0">
                    <vs-table stripe pagination :max-items="10" search :data="arrayUsuariosNoEncontrados">
                        <template slot="header">
                            <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
                                <vs-button v-if="arrayUsuariosNoEncontrados.length > 0 && tableData.length <= 1000" color="primary" type="gradient" icon-pack="feather" icon="icon-user-plus" @click="arraySendData = arrayUsuariosNoEncontrados;openConfirm()">
                                    Registrar usuarios
                                </vs-button>
                            </div>
                        </template>
                        <template slot="thead">
                            <vs-th>Cédula</vs-th>
                            <vs-th>Nombres</vs-th>
                            <vs-th>Apellidos</vs-th>
                            <vs-th>Email</vs-th>
                            <vs-th>institucion_id</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>{{ data[indextr].cedula }}</vs-td>
                                <vs-td>{{ data[indextr].nombres }}</vs-td>
                                <vs-td>{{ data[indextr].apellidos }}</vs-td>
                                <vs-td>{{ data[indextr].correo }}</vs-td>
                                <vs-td>{{ data[indextr].institucion_id }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </vx-card>
      <!--MODALES-->
  </div>
  </template>

  <script>
  import {
      mapState
  } from "vuex";
  import vSelect from 'vue-select'
  import ImportExcel from "../../../codigos/components/importExcel.vue";
  import XLSX from 'xlsx';
  export default {
      components: {
          ImportExcel,
          vSelect,
      },
      data() {
          return {
              codigosPerdidos: false,
              tableData: [],
              header: [],
              sheetName: '',
              usuario: [],
              modalConfirm: false,
              modalErrores: false,
              errores: [],
              modalCedulas: false,
              registroProblemas: [],
              cedulas_no_encontradas: [],
              porcentaje: 0,
              selecciondeusuario: '',
              classvalidar_selecciondeusuario: '',
              SeleccionUsuario: [
                  { text: '--Seleccione--', value: null },
                  { text: 'Docentes', value: 6 },
                  { text: 'Evaluación Docente', value: 13 },
                  { text: 'Estudiantes', value: 4 },
              ],
              arrayUsuarios: [],
              arrayUsuariosNoEncontrados: [],
              tablaSeleccionada: 0,
              arraySendData: [],
              filtroEstadoUsuario: 0, // 0=todos, 1=activos, 2=inactivos
              usuariosSeleccionados: [], // multiselect de usuarios existen
              activarUsuariosInactivos: false, // checkbox para activar usuarios inactivos
              mantenerGrupoActual: false, // checkbox para mantener grupo/rol actual
          }
      },
      computed: {
          ...mapState(["auth", 'userRoot', 'susuario', 'userAsesor']),
          usuariosExistentesCount() {
              if (!Array.isArray(this.arrayUsuarios)) return 0;
              return this.arrayUsuarios.length;
          },
          usuariosNoExistenCount() {
              if (!Array.isArray(this.arrayUsuariosNoEncontrados)) return 0;
              return this.arrayUsuariosNoEncontrados.length;
          },
          usuariosActivosCount() {
              if (!Array.isArray(this.arrayUsuarios)) return 0;
              return this.arrayUsuarios.filter(u => u.estadoUsuario === 1).length;
          },
          usuariosInactivosCount() {
              if (!Array.isArray(this.arrayUsuarios)) return 0;
              return this.arrayUsuarios.filter(u => u.estadoUsuario !== 1).length;
          },
          arrayUsuariosFiltrados() {
              if (!Array.isArray(this.arrayUsuarios)) return [];
              if (this.filtroEstadoUsuario === 0) {
                  return this.arrayUsuarios; // Todos
              } else if (this.filtroEstadoUsuario === 1) {
                  return this.arrayUsuarios.filter(u => u.estadoUsuario === 1); // Activos
              } else {
                  return this.arrayUsuarios.filter(u => u.estadoUsuario !== 1); // Inactivos
              }
          },
      },
      watch: {
          // Limpiar checkbox cuando se cambia a tabla de usuarios no existen
          tablaSeleccionada(newVal) {
              if (newVal === 0) {
                  this.activarUsuariosInactivos = false;
                  this.mantenerGrupoActual = false;
                  this.usuariosSeleccionados = [];
              }
          }
      },
      created() {
          this.usuario = JSON.parse(localStorage.getItem('usuario'));
          this.codigosPerdidos = false
      },
      methods: {
        descargarFormatoExcel() {
            // Formato de ejemplo
            const formato = [
                {
                    cedula: '1234567890',
                    nombres: 'Juan',
                    apellidos: 'Pérez',
                    correo: 'juan.perez@email.com',
                    institucion_id: '1',
                }
            ];
            const header = ['cedula', 'nombres', 'apellidos', 'correo', 'institucion_id'];
            // Usar XLSX para crear el archivo
            const ws = XLSX.utils.json_to_sheet(formato, {header});
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Formato');
            XLSX.writeFile(wb, 'formato_registro_usuarios.xlsx');
        },
        loadDataInTable({
            results,
            header,
            meta
        }) {
            this.header = header
            this.tableData = results
            this.sheetName = meta.sheetName
            this.codigosPerdidos = false
            this.registroProblemas = []
            this.usuariosSeleccionados = []
            this.validateCampos()
        },
        validateCampos(){
          let me = this;
          //validar que el archivo tenga los campos necesarios con un for para ver que no haga vacios
          const camposNecesarios = ['cedula', 'nombres', 'apellidos', 'correo', 'institucion_id'];
          for (let campo of camposNecesarios) {
              if (!me.header.includes(campo)) {
                  me.$vs.notify({
                      text: `El archivo cargado no contiene el campo necesario: ${campo}`,
                      color: 'warning',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle',
                      time: 8000,
                  });
                  // Limpiar datos cargados
                  me.tableData = [];
                  me.header = [];
                  me.sheetName = '';
                  return; // Salir de la función si falta un campo
              }
          }

          this.f_consultarUsuarios()

        },
        validarcampo_selecciondeusuario() {
            let me = this;
            const focus_selecciondeusuario = me.$refs.selecciondeusuario.$el.querySelector('input');
            focus_selecciondeusuario.focus();
            me.classvalidar_selecciondeusuario = 'stylevalidar';
            //Notificación de vacio
            me.$vs.notify({
                text: "Seleccione un perfil para continuar.",
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-triangle',
                time: 8000,
            });
            // Quitar la clase después de la duración de la animación
            setTimeout(() => {
                me.classvalidar_selecciondeusuario = '';
            }, 1500); // Ajusta según la duración de tu animación
        },
        f_consultarUsuarios(){
          let me = this;
          me.arrayUsuarios = [];
          me.arrayUsuariosNoEncontrados = [];
          let formData = new FormData();
          let json_usuarios = JSON.stringify(me.tableData);
          formData.append('action','Post_Traer_Data_Usuarios');
          formData.append('data_usuarios', json_usuarios);
          me.$vs.loading()
          me.$http.post(this.$server_url + 'metodosPostUsuario', formData)
              .then(res => {
                  me.$vs.loading.close()
                  if (res.data.status == 0) {
                      me.$vs.notify({
                          text: res.data.message,
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-check'
                      })
                      return false
                  }
                  // Convertir a array si viene como objeto
                  const dataUsuarios = res.data.dataUsuarios;
                  const usuariosNoEncontrados = res.data.usuariosNoEncontrados;
                  me.arrayUsuarios = Array.isArray(dataUsuarios) ? dataUsuarios : Object.values(dataUsuarios || {});
                  me.arrayUsuariosNoEncontrados = Array.isArray(usuariosNoEncontrados) ? usuariosNoEncontrados : Object.values(usuariosNoEncontrados || {});
              })
              .catch(function (error) {
                  me.$vs.notify({
                      text: 'Verifique que la información se haya guardado correctamente.',
                      color: 'warning',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
                  me.$vs.loading.close()
              })
        },
        procesarPagos() {
            let me = this
            let json_usuarios = JSON.stringify(me.arraySendData)
            let formData = new FormData();
            // console.log(this.selecciondeusuario, "idusuario");
            formData.append('data_usuarios', json_usuarios);
            formData.append('idusuario', me.usuario.idusuario);
            formData.append('id_group', me.selecciondeusuario)
            formData.append('tipoAccion', me.tablaSeleccionada)
            formData.append('activarUsuariosInactivos', me.activarUsuariosInactivos ? 1 : 0)
            formData.append('mantenerGrupoActual', me.mantenerGrupoActual ? 1 : 0)
            me.$vs.loading()
            this.$http.post(this.$server_url + 'importRegistroUsuarios', formData)
                .then(res => {
                    me.$vs.loading.close()
                    if (res.data.status == 0) {
                        me.$vs.notify({
                            text: res.data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                        return false
                    }
                    me.$vs.notify({
                        text: 'Cédulas procesadas exitosamente',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    me.modalConfirm = false
                    me.codigosPerdidos = true
                    me.registroProblemas = res.data.registroProblemas
                    me.porcentaje = res.data.cambiados
                    me.usuariosSeleccionados = []
                    me.f_consultarUsuarios()
                })
                .catch(function (error) {
                    me.$vs.notify({
                        text: 'Verifique que la información se haya guardado correctamente.',
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    })
                    me.$vs.loading.close()
                    // setTimeout(function() {location.reload()}, 1000);
                })
        },
        openConfirm(tipo) {
            let me = this
            me.tipo_selected = tipo
            if ((me.selecciondeusuario == 'undefined') || (me.selecciondeusuario == '') || (me.selecciondeusuario == null)) {
                me.validarcampo_selecciondeusuario();
                return
            }
            if (!me.tableData[0].cedula || !me.tableData[0].nombres || !me.tableData[0].apellidos || !me.tableData[0].correo || !me.tableData[0].institucion_id) {
                me.$vs.loading.close()
                me.$vs.notify({
                    text: 'Corrija el formato del excel y vuelva a intentar.',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                })
                return
            }
            me.errores = []
            $.each(me.tableData, function (key, value) {
                if (!value.cedula || !value.nombres || !value.apellidos || !value.correo || !value.institucion_id) {
                    me.errores.push(value)
                }
            })
            if (me.errores.length > 0) {
                me.modalErrores = true
            } else {
                me.modalConfirm = true
            }
        },
        recargar() {
            location.reload()
        },
        exportToExcel() {
            const wb = XLSX.utils.book_new();
            const sheet1Data = this.registroProblemas.map(item => ({
                'Cédula': item.cedula,
                'Nombres': item.nombres,
                'Apellidos': item.apellidos,
                'Correo': item.correo,
                'institucion_id': item.institucion_id,
                'Problema': item.problema,
            }));
            const ws1 = XLSX.utils.json_to_sheet(sheet1Data);

            XLSX.utils.book_append_sheet(wb, ws1, 'Registro Problemas');

            XLSX.writeFile(wb, 'Resultado_Proceso.xlsx');
        },
        exportarExisten() {
            const wb = XLSX.utils.book_new();
            const sheet1Data = this.arrayUsuariosFiltrados.map(item => ({
                'Cédula': item.cedula,
                'ID Usuario': item.idusuario,
                'Nombres Actual': item.nombres_bd,
                'Nombres Excel': item.nombres,
                'Apellidos Actual': item.apellidos_bd,
                'Apellidos Excel': item.apellidos,
                'Email': item.correo,
                'Institución Actual': item.nombreInstitucion_db,
                'Institución Excel': item.nombreInstitucion,
                'Grupo': item.grupo,
                'Estado': item.estado_usuario,
            }));
            const ws1 = XLSX.utils.json_to_sheet(sheet1Data);
            XLSX.utils.book_append_sheet(wb, ws1, 'Usuarios Existentes');
            XLSX.writeFile(wb, 'Usuarios_Existentes.xlsx');
        },
        limpiarArchivo() {
            // Limpiar todos los datos para permitir cargar un nuevo archivo
            this.tableData = [];
            this.header = [];
            this.sheetName = '';
            this.arrayUsuarios = [];
            this.arrayUsuariosNoEncontrados = [];
            this.codigosPerdidos = false;
            this.registroProblemas = [];
        },
      }
  }
  </script>

  <style scoped>
  .tabla {
      width: 100%;
      margin-top: 10px;
  }

  .tabla {

      border: 1px solid #D1E5F1;
      padding: 2px;
      border-radius: 5px;
  }

  .th1 {
      background-color: #092308;
      border-radius: 5px;
      color: white;
  }

  .td1,
  .th1 {
      padding: 10px;
      text-align: center;
      border: none;
  }

  .stylevalidar {
      /* border: 2px solid #00f; */
      box-shadow: 0px 0px 2px 4px #ff0000;
      border-radius: 5px;
  }
  </style>
